module.exports = __webpack_public_path__ + "img/118.73e9e4fc.jpg";